import React from "react";

const ProfileComplete = ({ profileComplete }) => {
  let classes = ["progress-bar"];
  if (profileComplete < 30) {
    classes.push("progress-bar-danger");
  } else if (profileComplete >= 30 && profileComplete < 60) {
    classes.push("progress-bar-warning");
  } else {
    classes.push("progress-bar-info");
  }
  return (
    <div className="profile-info text-left">
      Profile complete on <strong>{`${profileComplete}%`}</strong>
      <div className="progress progress-bar-xs">
        <div
          className={classes.join(" ")}
          role="progressbar"
          aria-valuenow={profileComplete}
          aria-valuemin="0"
          aria-valuemax="100"
          style={{ width: `${profileComplete}%` }}
        />
      </div>
    </div>
  );
};

export default ProfileComplete;



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/ProfileInfoWithImage/ProfileComplete/index.js